import {Document} from "@core/model";
import {ButtonBase, IconButton, Stack, Typography} from "@mui/material";
import {getFileIcon, truncateSx} from "@util";
import {DeleteIcon, DocumentIcon} from "../icons";
import {Admin} from "../Admin";
import {PreviewDialog} from "../preview";
import {useState} from "react";
import {api} from "@core/api";
import {DeleteDialog} from "@components/DeleteDialog";

const DocumentRow = ({
  document,
  onDelete,
}: {
  document: Document;
  onDelete: () => void;
}) => {
  const [deleteDocument, {isLoading}] = api.useDeleteDocumentsMutation();

  const handleDeleteDocument = () => {
    deleteDocument([document.id]).unwrap().then(onDelete);
  };

  const [open, setOpen] = useState<boolean>(false);
  const [preview, setPreview] = useState<Document>();

  return (
    <Stack direction={"row"} alignItems={"center"} gap={1}>
      <ButtonBase
        onClick={() => setPreview(document)}
        sx={{gap: 1, flex: 1, minWidth: 0, pl: 1, py: 1}}>
        {getFileIcon(document.type)}
        <Stack flex={1} minWidth={0} direction={"row"}>
          <Typography component={"span"} variant="body2" sx={truncateSx}>
            {document.name}
          </Typography>
        </Stack>
      </ButtonBase>
      <Admin>
        <IconButton size="small" onClick={() => setOpen(true)}>
          <DeleteIcon fontSize="inherit" />
        </IconButton>
      </Admin>
      <PreviewDialog
        document={preview}
        onClose={() => {
          setPreview(undefined);
        }}
      />
      <DeleteDialog
        open={open}
        data={document}
        isLoading={isLoading}
        EntityIcon={DocumentIcon}
        onConfirm={handleDeleteDocument}
        onClose={() => setOpen(false)}
      />
    </Stack>
  );
};

export {DocumentRow};
